import { AxiosError, AxiosResponse } from "axios";
import api from "../services/api";

export const form_process = async (id: number, data: any) => {
	try {
		const response = await api.patch(`data/process&id=${id}`, {
			infos: data,
		});

		return response;
	} catch (error) {
		return error;
	}
};

export const insertTypistData = async (
	id: number,
	data: any,
	place: "1" | "2",
): Promise<AxiosResponse> => {
	let formattedData: { [key: string]: any } = {};
	let key;

	for (key in data) {
		if (data[key] !== "" &&  data[key] !== null && data[key] !== undefined)  {
			formattedData[key] = data[key];
		}
	}

	try {
		if (place === "1") {
			const response = await api.patch(
				`data/process&id=${id}/insertTypistOneData`,
				{ data: formattedData },
			);

			return response;
		}

		const response = await api.patch(
			`data/process&id=${id}/insertTypistTwoData`,
			{ data: formattedData },
		);

		return response;
	} catch (error) {
		throw new Error('Ocorreu um erro no envio dos dados');
	}
};

export const list_process = async () => {
	try {
		const response = await api.get("data/process");

		return response;
	} catch (error) {
		return error;
	}
};

export const send_doc = async (cpf: string, data: any) => {
	try {
		const response = await api.patch(
			`/data/process/documents
    `,
			{
				cpf,
				documents: data,
			},
		);

		return response;
	} catch (error) {

		throw new Error('Ocorreu um erro no envio dos dados');
	}
};
